import React, { useEffect, createContext, useState } from 'react';
import 'App.css';
import { ThemeProvider } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import { muiTheme } from 'styles/theme';
import Navigator from './Navigator';
import { fetchData, fetchReview } from 'services/Api';

export const DataContext = createContext(null);

function App() {
  const [data, setData] = useState({
    packages: [],
    destinations: [],
    cities: [],
    reviews: [],
  });


  useEffect(() => {
    fetchData().then((packages) => {
      const destinationNames = new Set();
      const cities = new Set();
      packages.forEach(pkg => {
        const endDate = new Date(pkg.validity.endDate);
        const now = new Date();

        if (endDate < now) {
          return; // Skip packages that are expired
        }

        if (pkg.destination) {
          destinationNames.add(pkg.destination.trim());
        }
        if (pkg.cities) {
          pkg.cities.forEach(city => cities.add(city.trim()));
        }
      });

      const destinations = Array.from(destinationNames).map(name => {
        return { name, image: packages.find(pkg => pkg.destination.trim() === name)?.image || '' };
      })

      setData((prevData) => ({
        ...prevData,
        packages,
        destinations: destinations,
        cities: Array.from(cities),
      }));
    }).catch((error) => {
      console.error("Error fetching packages:", error);
    });

    fetchReview().then((reviews) => {
      setData((prevData) => ({
        ...prevData,
        reviews
      }));
    }).catch((error) => {
      console.error("Error fetching reviews:", error);
    });
  }, []);

  return (
    <ThemeProvider theme={muiTheme}>
      <CssBaseline />
      <DataContext.Provider value={data}>
        <div className="App">
          <Navigator />
        </div>
      </DataContext.Provider>
    </ThemeProvider>
  );
}

export default App;
